import { brand, medal } from '@alison/ui';
import { alpha, darken, lighten } from '@mui/material/styles';

export type Gradient = readonly [string, string];

const RAMP_BASE = brand.bgPurple;

export const GOLD_BASE = medal.gold;
export const GOLD_GRADIENT: Gradient = [medal.gold, lighten(medal.gold, 0.42)];
export const GOLD_TEXT = medal.gold;
export const GOLD_BADGE_BG = alpha(medal.gold, 0.16);

export function marketColor(index: number, count: number): string {
  const span = Math.max(1, count - 1);
  const shade = index / span;
  return lighten(darken(RAMP_BASE, 0.4), shade * 0.55);
}

export function flagGradient(index: number, count: number): Gradient {
  const color = marketColor(index, count);
  return [color, alpha(color, 0.8)];
}

export function performanceBarGradient(index: number): Gradient {
  if (index === 0) return GOLD_GRADIENT;
  return [darken(RAMP_BASE, 0.4), lighten(RAMP_BASE, 0.05)];
}

export function rankedBarGradient(index: number, count: number, leader: boolean): Gradient {
  if (leader) return GOLD_GRADIENT;
  const span = Math.max(1, count - 2);
  const shade = (index - 1) / span;
  return [darken(RAMP_BASE, 0.5 - shade * 0.3), lighten(RAMP_BASE, 0.05 + shade * 0.25)];
}

export function medalGradient(rank: number): Gradient | null {
  if (rank === 1) return [medal.gold, alpha(medal.gold, 0.8)];
  if (rank === 2) return [medal.silver, alpha(medal.silver, 0.8)];
  if (rank === 3) return [medal.bronze, alpha(medal.bronze, 0.8)];
  return null;
}
